export default __webpack_public_path__ + "static/media/vw-parts.86105cc3.png";